import { Controller } from "@hotwired/stimulus";
import IMask from "imask";
import dayjs from "../../src/dayjs";

const DATE_FORMAT = "DD/MM/YYYY";

const MASK_SETTINGS = {
  mask: Date,
  pattern: DATE_FORMAT,
  lazy: true,
  min: new Date(1900, 0, 1),
  max: new Date(2050, 0, 1),
  format: (date) => dayjs(date).format(DATE_FORMAT),
  parse: (str) => dayjs(str, DATE_FORMAT, true),
  blocks: {
    YYYY: {
      mask: IMask.MaskedRange,
      from: 1900,
      to: 2050,
    },
    MM: {
      mask: IMask.MaskedRange,
      from: 1,
      to: 12,
    },
    DD: {
      mask: IMask.MaskedRange,
      from: 1,
      to: 31,
    },
  },
};

export default class extends Controller {
  connect() {
    this.maskInstance = new IMask(this.element, MASK_SETTINGS);
    this.element.addEventListener("keydown", this.handleTab.bind(this));
  }

  disconnect() {
    if (this.maskInstance) {
      this.maskInstance.destroy();
    }
    this.element.removeEventListener("keydown", this.handleTab.bind(this));
  }

  handleTab(e) {
    if (e.key === "Tab") {
      const value = this.element.value;
      const date = dayjs(value, DATE_FORMAT, true);
      if (date.isValid()) {
        const endDate = date.add(1, "year");
        const formatted = endDate.format(DATE_FORMAT);
        // Find the end_date input in the same form
        let form = this.element.form;
        if (form) {
          let endDateInput = form.querySelector("#end_date");
          if (endDateInput && !endDateInput.disabled) {
            endDateInput.value = formatted;
          }
        }
      }
    }
  }
}
